import type { ReactNode } from "react";
import { Button } from "@/core/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";

interface IconButtonWithTooltipProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
}

export const IconButtonWithTooltip = ({
  label,
  onClick,
  disabled,
  children,
}: IconButtonWithTooltipProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span>
        <Button
          variant="icon"
          size="icon"
          aria-label={label}
          onClick={onClick}
          disabled={disabled}
        >
          {children}
        </Button>
      </span>
    </TooltipTrigger>
    <TooltipContent>{label}</TooltipContent>
  </Tooltip>
);
